import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/lib/api-client";
import type { DashboardResponse } from "@/types/api";

export const DASHBOARD_QUERY_KEY = ["account", "dashboard"];

export const useDashboardData = () =>
  useQuery<DashboardResponse>({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: () => apiClient.get<DashboardResponse>("/account/dashboard"),
  });
